// src\app\core\utils\normalize-error.ts
import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '../models/api-error.model';

export function normalizeError(error: unknown): ApiError {
  // HTTP error (backend respondeu com erro)
  if (error instanceof HttpErrorResponse) {
    return {
      code: error.error?.code || 'http-error',
      message: error.error?.message || 'Erro de comunicação com o servidor',
      status: error.status,
      details: error.error?.details,
    };
  }

  // objeto lançado manualmente (throw response)
  if (typeof error === 'object' && error !== null && 'code' in error) {
    return {
      code: (error as any).code,
      message: (error as any).message,
      details: (error as any).details,
    };
  }

  // erro JS padrão
  if (error instanceof Error) {
    return {
      code: 'unexpected',
      message: error.message,
    };
  }

  return {
    code: 'unknown',
    message: 'Erro inesperado',
  };
}
